import { Avatar, IconButton } from '@mui/material';
import { FC } from 'react';
import theme from 'context/createTheme';
import { useAuth0User } from 'hooks/useAuth0User';
import { useCurrentUser } from 'api/hooks/useCurrentUser';

interface UserAvatarProps {
  onClick: (bool) => void;
}

const UserAvatar: FC<UserAvatarProps> = ({ onClick }) => {
  const user = useAuth0User();

  const { data: currentUser } = useCurrentUser();
  const email = currentUser?.email || '';

  const initialsAvatar = user.isAuthenticated ? email?.slice(0, 2).toUpperCase() : 'G';

  return (
    <IconButton sx={{ padding: 0 }} onClick={onClick}>
      <Avatar
        sx={{
          bgcolor: user.isAuthenticated ? theme.colors.green : theme.colors.orange,
          '&:hover': {
            bgcolor: user.isAuthenticated ? theme.colors.active : theme.colors.amberDark,
          },
        }}
      >
        {initialsAvatar}
      </Avatar>
    </IconButton>
  );
};

export default UserAvatar;
